import { connect } from 'react-redux';
import { getSubcategorySlug } from 'common/ducks/categories';
import ProjectLink from 'common/components/project_link';

export function mapStateToProps({ categories }, { project }) {
  const subcategory = getSubcategorySlug(categories, project.sub_category || project.subcategory);
  return { subcategory };
}

export default connect(mapStateToProps)(ProjectLink);
